import styled from '@emotion/styled';

import { font } from '../../../Font/Font.styles';

export const Input = styled.input<{ invalid?: boolean }>`
  ${font('label-lg')};
  margin-top: var(--spacing-4);
  border: 1px solid var(--color-neutral-40);
  padding: var(--spacing-16);
  color: var(--color-black);
  outline: none;
  border-radius: var(--border-radius-m);
  display: block;
  width: 100%;
  box-sizing: border-box;

  &[aria-invalid='true'] {
    border-color: var(--color-status-error-dark);
  }
`;

export const Info = styled.p`
  ${font('body-sm')};
  margin-top: var(--spacing-8);
`;
